import { Component } from '@angular/core';
import { StreamService } from '../../../service/stream.service';
import { AppdataService } from '../../../service/appdata.service';
import { MatDialog } from '@angular/material/dialog';
import { EditTrackComponent } from '../edit-track/edit-track.component';
import { GeneratePromolinkComponent } from '../generate-promolink/generate-promolink.component';

@Component({
  selector: 'app-tracks',
  standalone: false,
  templateUrl: './tracks.component.html',
  styleUrl: './tracks.component.scss'
})
export class TracksComponent {
  hidespinner: boolean = true;
  tracks: any[] = [];
  categories: any[] = [];

  constructor(
    private streamService: StreamService,
    private appData: AppdataService,
    private dialog: MatDialog
  ) {
    appData.tracks.subscribe((data) => {
      this.tracks = data;
    });
  }

  async openPromo(track: any) {
    this.dialog.open(GeneratePromolinkComponent, { data: track });
  }
  async newTrack() {
    let track = {}
    this.hidespinner = false;
    let res = await this.streamService.addTrack(track);
    if (res !== false) await this.appData.loadAllTracks();
    this.hidespinner = true;
  }


  async newStream(track: any) {
    this.hidespinner = false;
    let res = await this.streamService.addStream(track.id, `My Stream (${track.streams.length})`, '', track.streams.length);
    if (res !== false) await this.appData.loadAllTracks();
    this.hidespinner = true;

  }
  async deleteTrack(track: any) {
    let result = await confirm('Are you sure you want to delete this track?');
    if (!result) return;
    this.hidespinner = false;
    let res = await this.streamService.deleteTrack(track.id);
    if (res !== false) this.appData.loadAllTracks();
    this.hidespinner = true;
  }

  async editTrack(track: any) {
    this.dialog.open(EditTrackComponent, { data: track });
  }
}
